import styled from "@emotion/styled";

import { zIndexes } from "@skilitics/designer-ui-components";
import type { SnapGuide } from "@skilitics/drag-drop";

const VerticalLine = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background: ${({ theme }) => theme.secondary};
  pointer-events: none;
  z-index: ${zIndexes.canvasSnapGuide};
`;

const HorizontalLine = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background: ${({ theme }) => theme.secondary};
  pointer-events: none;
  z-index: ${zIndexes.canvasSnapGuide};
`;

type SnapGuideLinesProps = {
  guides: SnapGuide[];
};

export const SnapGuideLines = ({ guides }: SnapGuideLinesProps) => (
  <>
    {guides.map((guide, index) =>
      guide.orientation === "vertical" ? (
        <VerticalLine key={`v-${index}`} style={{ left: guide.position }} />
      ) : (
        <HorizontalLine key={`h-${index}`} style={{ top: guide.position }} />
      ),
    )}
  </>
);
